import { BusinessAddress, usStates } from "@sp-crm/core";
import { Input } from "components/ui/input";
import { Select } from "components/ui/select";
import React from "react";
import { FieldProblem, StepHeading } from "./wizard-parts";
import { WizardStepProps } from "./wizard-step-props";

export const StepAddress: React.FC<WizardStepProps> = props => {
    const { details, problems, onChange } = props;
    const { address } = details;
    const setAddress = (changes: Partial<BusinessAddress>) =>
        onChange({ address: { ...address, ...changes } });

    return (
        <div className="space-y-6">
            <StepHeading
                title="Business address"
                description="The street address where your business operates. It should match what the IRS or your state has on file."
            />
            <div className="space-y-4">
                <div>
                    <Input
                        label="Street address"
                        value={address.street}
                        aria-invalid={!!problems["address.street"]}
                        onChange={e => setAddress({ street: e.target.value })}
                    />
                    <FieldProblem problem={problems["address.street"] ?? null} />
                </div>
                <div>
                    <Input
                        label="Suite or unit (optional)"
                        value={address.suite}
                        aria-invalid={!!problems["address.suite"]}
                        onChange={e => setAddress({ suite: e.target.value })}
                    />
                    <FieldProblem problem={problems["address.suite"] ?? null} />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                    <div className="col-span-2">
                        <Input
                            label="City"
                            value={address.city}
                            onChange={e => setAddress({ city: e.target.value })}
                        />
                        <FieldProblem problem={problems["address.city"] ?? null} />
                    </div>
                    <div>
                        <Select
                            label="State"
                            value={address.state}
                            onChange={e => setAddress({ state: e.target.value })}>
                            <option value="">Choose</option>
                            {usStates.map(state => (
                                <option key={state.code} value={state.code.toUpperCase()}>
                                    {state.name}
                                </option>
                            ))}
                        </Select>
                        <FieldProblem problem={problems["address.state"] ?? null} />
                    </div>
                    <div>
                        <Input
                            label="ZIP"
                            value={address.zip}
                            inputMode="numeric"
                            aria-invalid={!!problems["address.zip"]}
                            onChange={e =>
                                setAddress({
                                    zip: e.target.value.replace(/\D/g, "").slice(0, 5),
                                })
                            }
                        />
                        <FieldProblem problem={problems["address.zip"] ?? null} />
                    </div>
                </div>
            </div>
        </div>
    );
};
